import React from 'react';
import { AlertCircle, Radio, Bell } from 'lucide-react';
import { features } from '../data/mock';

export const SOSFeature = () => {
  const feature = features[2];
  
  return (
    <section className="py-24 bg-gradient-to-br from-rose-50 via-red-50 to-orange-50">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="text-rose-600 font-bold text-sm uppercase tracking-wider bg-rose-100 px-4 py-2 rounded-full">
                Emergency Safety
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              {feature.title}
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              {feature.description}
            </p>

            {/* Highlights */}
            <div className="space-y-4 pt-4">
              {feature.highlights.map((highlight, index) => {
                const icons = [AlertCircle, Radio, Bell];
                const Icon = icons[index];
                return (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon className="h-5 w-5 text-rose-600" />
                    </div>
                    <span className="text-gray-700 text-lg font-medium">{highlight}</span>
                  </div>
                );
              })}
            </div>

            {/* Emergency Note */}
            <div className="mt-8 p-6 bg-white rounded-2xl border-2 border-rose-200 shadow-lg">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-rose-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <AlertCircle className="h-6 w-6 text-rose-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">When SOS is activated:</h4>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-rose-500 rounded-full"></div>
                      Live location shared immediately
                    </li>
                    <li className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-rose-500 rounded-full"></div>
                      Your circle is notified instantly
                    </li>
                    <li className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-rose-500 rounded-full"></div>
                      Help can reach you faster
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative z-10 flex gap-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_8f3822bc-92b7-49eb-9b5e-cbe543e4f048/artifacts/aivwbuu8_Screenshot%202026-02-19%20at%2011.38.23%E2%80%AFAM.png"
                alt="SOS Emergency Feature"
                className="rounded-3xl shadow-2xl w-full max-w-md mx-auto transform hover:scale-105 transition-transform duration-300"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-rose-200 rounded-full opacity-50 blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-orange-200 rounded-full opacity-50 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
